import type { Poll, Program } from 'models';
import { Modal, message } from 'ui';
import { PollForm, type PollSubmitData } from '../form';
import { useUpdatePollMutation } from '../queries/mutations';

type P = {
  isOpened: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  poll: Poll;
  program?: Program;
};

const EditPoll = ({ isOpened, onCancel, onSuccess, poll, program }: P) => {
  const { isPending, mutate } = useUpdatePollMutation();

  const onSubmit = (values: PollSubmitData) => {
    mutate(values, {
      onError() {
        message.error('Failed to update poll.');
      },
      onSuccess() {
        onSuccess();
        message.success('Poll was updated.');
      },
    });
  };

  return (
    <Modal isOpened={isOpened} onCancel={onCancel} title="Edit Poll" width="medium">
      <Modal.HugContent>
        <PollForm edit loading={isPending} onSubmit={onSubmit} poll={poll} program={program} />
      </Modal.HugContent>
    </Modal>
  );
};

export default EditPoll;
